module.exports = __webpack_public_path__ + "static/media/logo.959a39fa.png";